import React, { FC, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import MultipleSelect from 'ui/MultipleSelect';
import Select from 'ui/Select';
import Button from 'ui/Button';
import { useUtils } from 'utils/useUtils';
import useOnClickOutside from 'utils/hooks/useOnClickOutside';
import { IFilterFormData, IFilterFormErrors } from './interfaces';

interface IFilter {
  isFilterVisible: boolean;
  setIsFilterVisible: (state: boolean) => void;
  setFilterOptions: (state: any) => void;
  setIsFilterActive: (state: boolean) => void;
}

const Filter: FC<IFilter> = ({ isFilterVisible, setIsFilterVisible, setFilterOptions, setIsFilterActive }: IFilter) => {
  const { BlacklistUtils } = useUtils();
  const { companies, reasons } = useSelector((state: any) => state.blacklistReducer);
  const countries = BlacklistUtils.getAutofillData(companies, 'country_name', '');
  const [filterFormData, setFilterFormData] = useState<IFilterFormData>({
    reason: [],
    country_name: '',
  });
  const [filterFormErrors, setFilterFormErrors] = useState<IFilterFormErrors>({
    reason: '',
    country_name: '',
  });

  const filterRef = useRef<HTMLDivElement>(null);

  const clearFilterHandler = () => {
    setFilterFormData((state: any) => {
      return {
        ...state,
        reason: [],
        country_name: '',
      };
    });
    setIsFilterActive(false);
  };

  const saveFilterHandler = () => {
    setFilterOptions(filterFormData);

    setIsFilterVisible(false);

    if (BlacklistUtils.isFormDataEmpty(filterFormData)) {
      setIsFilterActive(false);
    } else {
      setIsFilterActive(true);
    }
  };

  useOnClickOutside(filterRef, () => setIsFilterVisible(false));

  return (
    <div className={`blacklist__filter ${isFilterVisible ? 'is-visible' : ''}`} ref={filterRef}>
      <form className="blacklist__filter-form" autoComplete="off">
        <div className="blacklist__filter-form-section">
          <MultipleSelect
            id="reason"
            name="reason"
            label="Reason"
            placeholder="Select"
            value={filterFormData.reason}
            error={filterFormErrors.reason}
            dropdownItems={reasons}
            filterFormData={filterFormData}
            setFilterFormData={setFilterFormData}
            setFilterFormErrors={setFilterFormErrors}
            // isRequired
          />
        </div>
        <div className="blacklist__filter-form-section">
          <Select
            id="new-select-country"
            name="country_name"
            label="Country"
            placeholder="Select"
            value={filterFormData.country_name}
            error={filterFormErrors.country_name}
            dropdownItems={countries.sort((a: any, b: any) => a.localeCompare(b))}
            setFormData={setFilterFormData}
            setFormErrors={setFilterFormErrors}
            readOnly={true}
            // isRequired
          />
        </div>
      </form>
      <div className="blacklist__filter-actions">
        <Button
          name="button-add"
          action={clearFilterHandler}
          customStyle={{
            width: '80px',
          }}
        >
          <span className="blacklist__filter-button-label" style={{ color: '#000c37' }}>
            Clear
          </span>
        </Button>
        <Button
          name="button-add"
          action={saveFilterHandler}
          stylePreset="dark"
          customStyle={{
            width: '80px',
            color: '#ffffff',
          }}
        >
          <span className="blacklist__filter-button-label" style={{ color: '#ffffff' }}>
            Save
          </span>
        </Button>
      </div>
    </div>
  );
};

export default React.memo(Filter);
